/**
 * Onboarding API client — org signup, invites, team, password reset.
 */
import axios from 'axios';
import { usePortalStore } from '../stores';

const API = process.env.REACT_APP_BACKEND_URL;
const base = `${API}/api/portal`;

const authClient = axios.create({ baseURL: base });
authClient.interceptors.request.use((cfg) => {
  const token = usePortalStore.getState().token;
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

const publicClient = axios.create({ baseURL: base });

// Exported so other features (notifications, orders) can reuse the
// pre-configured authenticated portal client.
export { authClient, publicClient };

export const onboardingApi = {
  orgSignup: (body) => publicClient.post('/auth/org-signup', body),
  personalSignup: (body) => publicClient.post('/auth/personal-signup', body),
  verifyInvite: (token) => publicClient.get(`/invites/verify/${token}`),
  acceptInvite: (body) => publicClient.post('/invites/accept', body),
  forgotPassword: (email) => publicClient.post('/auth/forgot-password', { email }),
  resetPassword: (token, password) => publicClient.post('/auth/reset-password', { token, password }),

  // Admin-only
  listInvites: () => authClient.get('/invites'),
  createInvite: (body) => authClient.post('/invites', body),
  revokeInvite: (id) => authClient.delete(`/invites/${id}`),
  resendInvite: (id) => authClient.post(`/invites/${id}/resend`),

  listTeam: () => authClient.get('/team'),
  updateMember: (id, body) => authClient.put(`/team/${id}`, body),
  removeMember: (id) => authClient.delete(`/team/${id}`),

  // Notifications
  getNotificationPrefs: () => authClient.get('/me/notifications'),
  setNotificationPrefs: (prefs) => authClient.post('/me/notifications', { prefs }),
};
